import React, {useState, useEffect} from "react";
import ResetSuccess from "./Assets/ResetSuccess.svg";

const InstitutePasswordCreatedSuccessPopup = ({setPasswordResetSuccessShowPopup }) => {
   
  const closePopup = () =>{
      console.log("Close icon clicked");
      setPasswordResetSuccessShowPopup(false);
  }
    return (
        <div className="">
          <div className="flex justify-center items-center">
            <img src={ResetSuccess} alt="success reset password" className='w-[40px] h-[40px]'/>
          </div>
          <h2
            className=" mb-4 text-center text-[16px] mt-[10px]"
          >
            Congratulations !!
          </h2>
          <p className="text-center text-[14px] w-[300px]">You have successfully created your password. Click on <span className="font-bold">"Back to Home" </span>to Login.</p>
          <div className="w-full flex justify-center items-center gap-[15px] mt-[20px]">
            <button
                className="px-[15px] py-[7px] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={() => {
                    const isLocalhost = window.location.hostname === "localhost";
                    window.location.href = isLocalhost
                    ? "http://localhost:3000"
                    : "https://vehiclelearning.com/"; // Replace with your live site URL
                }}
                style={{border:"2px solid #A1A3EF"}}>
               Back To Home
            </button>
          </div>
        </div>
    );
  };

export default InstitutePasswordCreatedSuccessPopup;
